import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ import!
// import Back from "../../assets/image/login/back_icon.svg";
import { useLocation } from "react-router-dom";
import Next from "../../assets/image/main/next.png";
import axios from "axios";
import "../../styles/scroll.css"; // 오타 없이 정확하게!
import { FiArrowLeft } from "react-icons/fi";

const channelMap = {
    1: "카카오톡",
    2: "인스타 스토리",
    3: "인스타 게시물",
    6: "네이버 밴드"
};

const titleMap = {
    1: "매장 홍보",
    2: "상품 소개",
    3: "이벤트",
};

const styleMap = {
    1: "3D감성",
    2: "포토실사",
    3: "캐릭터/만화",
    4: "레트로",
    5: "AI모델",
    6: "예술",
};

const AutoMarketing = () => {
    const location = useLocation();
    const data = location.state; // 여기서 data 꺼내기!
    const navigate = useNavigate();
    const [marketingList, setMarketingList] = useState([]);
    const userId = localStorage.getItem("user_id");
    const storeBusinessNumber = data.store_business_number

    // 목록 가져오기 (활성화 된)
    useEffect(() => {
        const sendGenerateRequest = async () => {
            const recentData = {
                user_id: userId,
                type: "auto",
            };
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/user/recent/record/auto`,
                    recentData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                const sortedList = response.data.reco_list
                    .sort(
                        (a, b) =>
                            new Date(b.start_date) - new Date(a.start_date)
                    ) // 최신 날짜 우선
                    .map((item, index) => ({
                        src: item.image_path,
                        id: item.user_record_id,
                        prompt: `${channelMap[item.channel]} / ${
                            titleMap[item.title]
                        }`,
                        uploadTime: item.upload_time,
                        alertCheck: item.alert_check,
                        tags: [
                            channelMap[item.channel],
                            titleMap[item.title],
                            `${item.age}대`,
                            styleMap[item.style],
                            `${item.start_date}~${item.end_date}`,
                            item.repeat_time
                                ? `${item.repeat_time} 포스팅`
                                : "",
                        ].filter(Boolean),
                    }));

                setMarketingList(sortedList);
            } catch (error) {
                console.error("자동화 광고 생성 중 오류:", error);
                // alert("광고 생성에 실패했습니다. 다시 시도해주세요.");
            }
        };

        sendGenerateRequest();
    }, [userId]);

    const handleNewAdCreation = () => {
        navigate(`/auto/marketing/loading`, {
            state: data,
        });
    };

    const moveBack = () => {
        navigate("/ads/main", { state: { storeBusinessNumber } });
    };

    const moveUpdate = (item, data) => {
        navigate(`/auto/marketing/update`, {
            state: { item, data },
        });
    };

    return (
        <div className="min-h-screen flex flex-col p-8 ">
            {/* 로딩 화면 */}
            <button onClick={moveBack} className="pb-10">
                <FiArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <div className="pb-6">
                <h1 className="text-2xl font-bold pb-2">
                    마케팅 자동화 모드입니다.
                </h1>
                <p className="font-semibold">
                    자동목록을 선택하시거나 자동화 광고만들기
                </p>
                <p className="font-semibold">버튼을 눌러주세요.</p>
            </div>

            <h2 className="text-xl font-bold pb-4 ">마케팅중인 자동화 목록</h2>
            <div className="flex-grow overflow-y-auto pr-2 custom-scrollbar max-h-[50vh] border border-gray-300 p-4 rounded-lg">
                <div className="space-y-4">
                    {marketingList.length === 0 ? (
                        <div className="text-gray-500 text-sm">
                            자동화 마케팅 목록이 없습니다
                        </div>
                    ) : (
                        marketingList.map((item) => (
                            <div
                                key={item.id}
                                className="flex border rounded-2xl items-start space-x-4 shadow-sm"
                            >
                                <img
                                    src={item.src}
                                    alt="예시 이미지"
                                    className="w-20 aspect-square object-cover rounded-md"
                                />

                                {/* 상세내용 */}
                                <div className="">
                                    <p className="py-1 text-sm font-semibold">
                                        Prompt : {item.prompt}
                                    </p>
                                    <div className="flex flex-row">
                                        <div className="flex flex-wrap gap-2">
                                            {item.tags.map((tag, idx) => (
                                                <span
                                                    key={idx}
                                                    className="bg-blue-100 text-blue-600 rounded-lg px-1 py-1 text-2xs"
                                                >
                                                    {tag}
                                                </span>
                                            ))}
                                        </div>
                                        <div className="p-2">
                                            <img
                                                src={Next}
                                                alt="다음"
                                                className="w-6 h-4"
                                            />
                                        </div>
                                    </div>

                                    <div className="py-2">
                                        <button
                                            className="py-1 px-4 border border-[#7864F9] text-black rounded-md text-sm"
                                            onClick={() =>
                                                moveUpdate(item, data)
                                            }
                                        >
                                            수정하기
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* 하단 버튼 */}
            {/* 하단 고정 버튼 (스크롤과 충돌 없이 화면 하단에 붙음) */}
            <div className="sticky bottom-0 bg-white pt-8 pb-6 z-10">
                <div className="flex gap-4">
                    <button
                        onClick={moveBack}
                        className="bg-gray-400 text-white rounded-xl px-4 py-3 whitespace-nowrap w-full"
                    >
                        <p className="text-sm">취소</p>
                    </button>
                    <button
                        onClick={handleNewAdCreation}
                        className="bg-[#7864F9] text-white rounded-xl w-full justify-center px-4 py-3  items-center whitespace-nowrap"
                    >
                        <span className="text-base">
                            새로운 자동화 광고 만들기
                        </span>
                        <span className="text-base pl-2">+</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AutoMarketing;
